export type SiteLocale = 'ru' | 'kg';

function localeFromUrl(): SiteLocale {
  if (typeof window === 'undefined') return 'kg';
  const requested = new URLSearchParams(window.location.search).get('lang')?.toLowerCase();
  return requested === 'ru' ? 'ru' : 'kg';
}

export const siteLocale: SiteLocale = localeFromUrl();
export const isKyrgyz = siteLocale === 'kg';
export const documentLanguage = isKyrgyz ? 'ky' : 'ru';

export function localeText<T>(russian: T, kyrgyz: T): T {
  return isKyrgyz ? kyrgyz : russian;
}

export function localeHref(locale: SiteLocale): string {
  if (typeof window === 'undefined') return `?lang=${locale}`;
  const url = new URL(window.location.href);
  url.searchParams.set('lang', locale);
  return `${url.pathname}${url.search}${url.hash}`;
}

export const documentCopy = localeText(
  {
    title: 'Аманбек Карыпкулов — биография · 1939–2008',
    description: 'Документальная биография Аманбека Карыпкулова: Кара‑Суу, образование, наука, государственная служба, телевидение, дипломатия, семья и память.',
    start: 'Начать',
    languageLabel: 'Выбор языка',
    russianVersion: 'Русская версия',
    kyrgyzVersion: 'Кыргызская версия',
  },
  {
    title: 'Аманбек Карыпкулов — өмүр баян · 1939–2008',
    description: 'Аманбек Карыпкуловдун даректүү өмүр баяны: Кара‑Суу, билим алуу, илим, мамлекеттик кызмат, телерадио, дипломатия, үй-бүлө жана элес.',
    start: 'Окууну баштоо',
    languageLabel: 'Тилди тандоо',
    russianVersion: 'Орусча версия',
    kyrgyzVersion: 'Кыргызча версия',
  },
);

export function applyDocumentLocale(): void {
  document.documentElement.lang = documentLanguage;
  document.documentElement.dataset.locale = siteLocale;
  document.title = documentCopy.title;

  const description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (description) description.content = documentCopy.description;

  const start = document.querySelector<HTMLAnchorElement>('[data-site-start]');
  if (start) start.textContent = documentCopy.start;

  const languageSwitch = document.querySelector<HTMLElement>('[data-locale-switch]');
  languageSwitch?.setAttribute('aria-label', documentCopy.languageLabel);

  for (const link of document.querySelectorAll<HTMLAnchorElement>('[data-locale]')) {
    const locale = link.dataset.locale === 'kg' ? 'kg' : 'ru';
    link.href = localeHref(locale);
    link.setAttribute('aria-label', locale === 'kg' ? documentCopy.kyrgyzVersion : documentCopy.russianVersion);
    if (locale === siteLocale) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  }
}
